export const theme = (state) => state.theme
